/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Kind_AssistantInputs */

const cs_pipelines_kind_assistant = /** @type {(inputs: Pipelines_Kind_AssistantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asistent`)
};

const en_pipelines_kind_assistant = /** @type {(inputs: Pipelines_Kind_AssistantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assistant`)
};

/**
* | output |
* | --- |
* | "Assistant" |
*
* @param {Pipelines_Kind_AssistantInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_kind_assistant = /** @type {((inputs?: Pipelines_Kind_AssistantInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Kind_AssistantInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_kind_assistant(inputs)
	return cs_pipelines_kind_assistant(inputs)
});